import makeStyles from '@mui/styles/makeStyles';

const tableStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 175,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  table: {},
  root: {},
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
  expandedColumn: {
    display: 'inline-block',
  },
  grid: {
    flexGrow: 1,
  },
  gridItem: {
    width: 600,
  },
  expandableRowContainer: {
    backgroundColor: 'gainsboro',
  },
  expandableRow: {
    paddingBottom: 0,
    paddingTop: 0,
  },
  expandableRowText: {
    '& p': {
      display: 'inline-block',
    },
  },
  expandableRowValue: {
    fontWeight: 'bold',
    marginLeft: 2,
  },
  headerCell: {
    backgroundColor: '#fff',
    height: '8vh',
    minWidth: '5vh',
    maxWidth: '10vh',
  },
  headerLabel: {
    marginRight: '-18px',
  },
  footer: {
    padding: theme.spacing(1),
    width: '100%',
  },
  toggleArrow: {
    padding: '0 10px 0 0',
  },
  tableRow: {
    // backgroundColor: 'blue',
  },
  tableCell: {
    '$hover:hover &': {
      color: 'pink',
    },
  },
  expandableRowItem: {
    padding: 2,
  },
  sendButton: {
    width: 200,
  },
  hover: {},
  // tableRow: {
  //   'Mui-selected:hover': {
  //     'background-color': 'rgba(255, 204, 17, 0)',
  //   },
  // },
}));
export default tableStyles;
